<template>
    <basic-container>
        <avue-form :option="formConfig" ref="formRef" v-model="formData">
            <template slot="entProdVal">
                <el-input-number class="el_input_number_append unit_hundred_million" v-model="formData.entProdVal"
                    controls-position="right" :min="0" ></el-input-number>
            </template>
            <template slot="entTaxVal">
                <el-input-number class="el_input_number_append unit_million" v-model="formData.entTaxVal"
                    controls-position="right" :min="0" ></el-input-number>
            </template>
            <template slot="investVal">
                <el-input-number class="el_input_number_append unit_hundred_million" v-model="formData.investVal"
                    controls-position="right" :min="0" ></el-input-number>
            </template>
            <template #visitContractPerson>
                <div class="person-container">
                    <el-button type="primary" size="mini" @click="createNewConact">新增联系人</el-button>
                    <div v-if="personList.length > 0" v-for="(item, index) in personList" :key="index" class="person-con">
                        <div class="person-item flex-con">
                            <span class="person-item-title">{{ `${item.name}/${item.phone}/${item.job}` }}</span>
                            <div class="button-right">
                                <el-button type="text" @click="editPerson(index)">编辑</el-button>
                                <el-divider direction="vertical"></el-divider>
                                <el-button type="text" style="color: #f56c6c;" @click="deletePerson(index)">删除</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </avue-form>
        <!-- 附件上传 -->
        <div class="el-collapse-item is-active">
            <div class="avue-group__header avue-group">
                <div class="avue-group__title">
                    辅证材料
                </div>
            </div>
            <div  class="el-collapse-item__content">
                <Accessory
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(153, 153, 153, 0.8)"        
                    :projectid="projectId"
                    :dynamicId="projectId"
                    fileMenuUrlname="数字化招商平台"
                    idname="项目申报"
                    :upload="true"
                    />
            </div>
        </div>
        
       

        <!-- <InfoContainer 
            v-if="projectId != ''" 
            :infoTitle="uploadConfig['infoTitle']"
            :contentConfig="uploadConfig['infoContent']" 
            :uploadButton="false" 
            @uploadClick="chooseFile"
        >
            <template #content>
                <Accessory
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(153, 153, 153, 0.8)"        
                    :projectid="projectId"
                    :dynamicId="projectId"
                    fileMenuUrlname="数字化招商平台"
                    idname="项目申报"
                    :upload="true"
                    />
            </template>
        </InfoContainer> -->
        <div class="bottom-submit-con">
            <el-button :loading="formLoading" type="primary" plain @click="onSubmit()">提交</el-button>
        </div>

        <el-dialog title="新增联系人" :visible.sync="dialogVisible" width="30%">
            <avue-form ref="addPersonRef" v-model="personFormData" :option="addPersonFormConfig">
            </avue-form>
            <div class="submit-con">
                <el-button  type="primary" size="mini" @click="dialogVisible = false">取消</el-button>
                <el-button  type="primary" size="mini" plain @click="addPerson()">确定</el-button>
            </div>
        </el-dialog>
    </basic-container>
</template>
<script>
import InfoContainer from "@/components/infoContainer/zsInfoContainer";
import Accessory from "@/components/accessoriesother/accessoryFactor";
import {
    visitDeclareConfig,
    addPersonFormConfig
} from "./config.js";
import { validatenull } from "@/util/validate";
import * as api from '@/api/zs/zs';
import util from "@/mixins/util";
export default {
    name: 'visitDeclare',
    mixins: [util],
    data() {
        return {
            formConfig: visitDeclareConfig(),
            addPersonFormConfig: addPersonFormConfig(),
            formData: {
                projectType: '',
                num: undefined,
                num2: undefined
            },
            personFormData: {
                index: '',
                name: '',
                phone: '',
                job: ''
            },
            projectId: '',
            dialogVisible: false,
            uploadConfig: {
                infoTitle: "附件上传",
                infoContent: [
                    {
                        title: "",
                        prop: "content",
                    },
                ],
            },
            formLoading:false,
            personList: [],
        }
    },
    components: {
        Accessory,
        InfoContainer
    },
    watch:{
        "formData.investInten":{
            handler(val){
                if(!validatenull(val)){
                    this.formConfig.group[2].column.map(item=>{
                        if(['projectIntro','projectType','investVal'].includes(item.prop)){
                            item.display=this.formData.investInten==1?true:false
                        }
                    })
                   
                }

            }
        }
    },
    async mounted() {
        // 创建ID
        if (this.$route.params.id == '-1') {
            this.projectId = await this.setNewId();
            // this.formData.investInten=1
        } else {
            this.projectId = this.$route.params.id
            this.queryDetail()
        }
    },
    methods: {
        //详情
        async queryDetail() {
            const params = { id: this.projectId }
            const res = await api.getVisitDeclareDetail(params)
            if (res.data.code == 200) {
                const data = res.data.data
                this.formData=data
                this.personList=this.formData.visitContractPerson
            }

        },
        //提交
        onSubmit() {
            let that = this
            this.formLoading = true
            this.$refs.formRef.validate(async (valid, done) => {
                if (valid) {
                    let params = {
                        id:that.projectId,
                        ...this.formData,
                        visitContractPerson:validatenull(this.formData.visitContractPerson)?[]:this.formData.visitContractPerson
                       
                    };
                    if(params.investInten==0){
                        params.projectIntro =""
                        params.projectType =""
                        params.investVal =""
                    }
                    api.submitVisitDeclare(params).then(
                        (res) => {
                            if(res.data.code==200){
                                that.dialogVisible = false;
                                that.$message({
                                    type: "success",
                                    message: "操作成功!",
                                });
                                that.$router.push({path: `/zsProject/queryStatistical/visitQueryDetail/${that.projectId}`})
                                
                            }
                            that.formLoading = false
                            done()
                        }
                    );
                } else {
                    that.$message.warning('请填写必填项后提交')
                    that.formLoading = false
                    done()
                }
            });
        },


        //新增联系人
        createNewConact() {
            if (this.$refs.addPersonRef) {
                this.$refs.addPersonRef.resetForm()
            }
            this.dialogVisible = true
        },
        //编辑
        editPerson(index) {
            this.personFormData.index = index
            this.personFormData = this.personList[index]
            this.dialogVisible = true
        },
        // 删除personList中序号为index的元素
        deletePerson(index) {
            this.personList.splice(index, 1)
            this.formData.visitContractPerson = JSON.parse(JSON.stringify(this.personList))
        },
        // 新增或修改联系人
        addPerson() {
            const self = this
            
            this.$refs.addPersonRef.validate((valid, done) => {
                if (valid) {
                    if (!isNaN(Number(self.personFormData.index)) && self.personFormData.index !== '') {
                        self.personList[self.personFormData.index].name = self.personFormData.name
                        self.personList[self.personFormData.index].phone = self.personFormData.phone
                        self.personList[self.personFormData.index].job = self.personFormData.job
                        self.formData.visitContractPerson = self.personList
                        self.personFormData.index = ''
                    } else {
                        self.personList.push(JSON.parse(JSON.stringify(self.personFormData)))
                        self.formData.visitContractPerson = JSON.parse(JSON.stringify(self.personList))
                    }
                    this.dialogVisible = false
                    
                    done()
                } else {
                    done()
                }
            })
        },

    }
}

</script>
<style lang="scss" scoped>
.unit_hundred_million {
    &:after {
        content: '亿元';
    }
}

.unit_million {
    &:after {
        content: '万元';
    }
}

.submit-con {
    text-align: right;
    padding-top: 15px;
    border-top: 1px solid #e4e4e4e4;
}

.bottom-submit-con {
    width: 100%;
    text-align: center;
    padding-bottom: 20px;

    button {
        width: 150px;
    }
}
.flex-con {
    display: flex;
    justify-content: space-between;
    align-items: center; 
  }
.el-collapse-item__content {
    padding:0px 50px 50px 50px;
}

/deep/ .avue-group {
    pointer-events: none;
}

/deep/ .el-collapse-item__wrap {
    pointer-events: all;
}

/deep/ .avue-group .el-collapse-item__arrow {
    display: none;
}

/deep/ .avue-group__title {
    position: relative;
    padding-left: 16px;
    font-weight: 700;
    // font-size: 13px;
    color: #333;
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-left: 18px;

    &::before {
        position: absolute;
        content: "";
        width: 6px;
        height: 18px;
        background: #409EFF;
        top: 50%;
        left: 0;
        transform: translateY(-50%);

        // border-radius: 50%;
    }
}
</style>
